<template>
    <div :ref="stepName">
        <div class="form-header">
            <div class="cookbook-wrapper">
                <img class="ta-magazine" src="/images/fr_multigift_carousel/TA-Magazine-Mockup-NL.png" alt="magazine">
                <div>
                    <h4>
                        Ontvang je <br>
                        <span>gratis e-book</span>
                    </h4>
                    <p>“ 9 Onweerstaanbare <br>
                        Recepten met de <br> Airfryer ”</p>
                </div>
            </div>
        </div>
        <AddressForm></AddressForm>
    </div>
</template>

<script>
import AddressForm from "./AddressForm";
import mixin from "../../../travel_step_mixin";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { AddressForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
